import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

export const Layout = ({ children }) => {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <ScrollToTop />
      <div className="noise-overlay" />
      <Navbar />
      <main className="min-h-screen bg-white">{children}</main>
      <Footer />
      <FloatingActions />
      {/* bottom spacer so mobile sticky bar doesn't cover footer */}
      <div className="h-20 md:hidden" />
    </ReactLenis>
  );
};

export default Layout;
